import Grid from '@mui/material/Unstable_Grid2/Grid2';
import
{
  Container,
  StyledPrice,
  StyledTitle,
} from './AddonCardPrices.styles';

const AddonCardPrices = ({ monthlyClubPrice, yearlyClubPrice, isActive }) =>
{
  return (
    <Grid container spacing={0} columns={8}>
      <Grid xs={2}></Grid>
      <Grid xs={2}><StyledPrice>${monthlyClubPrice}</StyledPrice></Grid>
      <Grid xs={2}><StyledPrice>${yearlyClubPrice}</StyledPrice></Grid>
      <Grid xs={2}></Grid>
      <Grid xs={2}></Grid>
      <Grid xs={2}><span>Per Month</span></Grid>
      <Grid xs={2}><span>Per Year</span></Grid>
      <Grid xs={2}></Grid>

    </Grid >
  );
};

export default AddonCardPrices;
